import type { TovSourceResponse } from "contracts/api/client-tov/sources.responses";
import type { TovGuidanceProvenance } from "../../enums/tov";
import { TOV_GUIDANCE_PROVENANCE } from "../../enums/tov";

type GuidanceProvenance = {
  state: TovGuidanceProvenance;
  label: string;
  description: string;
};

// Debt: provenance is inferred by title match because tov_sources has no
// origin column; renaming the baseline source flips every badge to
// "Client-supplied". A real origin flag needs a contract + schema change.
const FARO_BASELINE_SOURCE_TITLE = "faro brand, cx & content guidelines";

export function guidanceProvenance(
  sources: TovSourceResponse[] | undefined,
): GuidanceProvenance {
  if (!sources || sources.length === 0) {
    return {
      state: TOV_GUIDANCE_PROVENANCE.UNKNOWN,
      label: "Source not established",
      description:
        "No source is attached. The guidance remains available as assessment context but is not presented as client-supplied or source-backed.",
    };
  }
  const baselineCount = sources.filter(
    (source) =>
      source.title.trim().toLowerCase() === FARO_BASELINE_SOURCE_TITLE,
  ).length;
  if (baselineCount === sources.length) {
    return {
      state: TOV_GUIDANCE_PROVENANCE.FARO_BASELINE,
      label: "Faro baseline guidance",
      description:
        "Default assessment context supplied by Faro. It is not client-supplied brand guidance.",
    };
  }
  if (baselineCount > 0) {
    return {
      state: TOV_GUIDANCE_PROVENANCE.MIXED,
      label: "Client sources + Faro baseline guidance",
      description:
        "Client-attached sources are supplemented by Faro's default assessment context.",
    };
  }
  return {
    state: TOV_GUIDANCE_PROVENANCE.CLIENT,
    label: "Client-supplied guidance",
    description:
      "Guidance is supported by sources attached to this client profile.",
  };
}
